import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FullsizeService {

  public fullsizeComponent = new BehaviorSubject<string>('');

  constructor() { }

  public setFullsize(component: string) {
    this.fullsizeComponent.next(component);
  }

}
